import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App'
import split from 'lodash/split'
import registerServiceWorker from './registerServiceWorker';

// let url_params = window.location.search.slice(1)
// let params = _.split(url_params, '&')
// console.log(params)
// params.map(param => {
//     const id_regex = /id=/g
//     if(param.match(id_regex)){
//         const splited = _.split(param, '=')
//         console.log('splited', splited[1])
//         seminar_id = parseFloat(splited[1])
//     }else if(param.match(cookie_regex)){
//         const splited = _.split(param, '=')
//         console.log('cookie splited', splited[1])
//         cookie_id = parseFloat(splited[1])
//     }
// })

let directory_id = 0
let params_labels = ['id', 'postal']
let url_params = window.location.search.slice(1)
let params_values = {}
let params = split(url_params, '&')
params.map(param => {
    // params_labels.forEach(param_label => {
    //     const regex = new RegExp(`${param_label}=`, 'g')
    //     if(param.match(regex)){
    //         const splited = split(param, '=')
    //         params_values[param_label] = parseFloat(splited[1])
    //     }
    // })
})

console.log('PARAMS VALUES', params_values)
console.log('LAUNCH ENV', process.env.NODE_ENV == "development" ? "Environnement de développement" : "Environnement de production")

ReactDOM.render(<App url={process.env.NODE_ENV == 'development' ? "http://192.168.1.63" : ""} {...params_values} devmode={process.env.NODE_ENV == 'development'} />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js